module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"validationErr":"Ce champ est obligatoire"},"en":{"validationErr":"This field is mandatory"}}')
  delete Component.options._Ctor
}
